"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(prop) {
  return !!prop ? function (ele, i, arr) {
    return arr.map(function (ele) {
      return ele[prop];
    }).indexOf(ele[prop]) === i;
  } : function (ele, i, arr) {
    return arr.indexOf(ele) === i;
  };
};

exports["default"] = _default;